export enum I18nShared {
  notes = 'notes',
}
